<template>
  <div>
    <a-modal :visible="visible" title="批量编辑" :confirm-loading="loading" @ok="handleOk" @cancel="handleCancel">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="变更字段" prop="key">
          <a-select v-model="form.key" style="width: 100%" @change="onFieldChange">
            <a-select-option v-for="item in fields" :key="item.value" :value="item.value"> {{ item.label }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="['strategy', 'projects', 'special_tests'].includes(form.key)" label="变更方式" prop="key">
          <a-select v-model="form.method" style="width: 100%">
            <a-select-option value="cover"> 覆盖 </a-select-option>
            <a-select-option value="append"> 追加 </a-select-option>
            <a-select-option value="remove"> 移除 </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="变更值" prop="value">
          <template v-if="form.key === 'owner'">
            <user-select v-model="form.value" placeholder="请选择负责人" show-search />
          </template>
          <template v-else-if="form.key === 'domain'">
            <a-select v-model="form.value" show-search placeholder="请选择所属域">
              <a-select-option v-for="domain in domainList" :key="domain.value" :value="domain.value">{{ domain.label }} </a-select-option>
            </a-select>
          </template>
          <template v-else-if="form.key === 'strategy'">
            <a-select v-model="form.value" mode="multiple" placeholder="请选择发布策略">
              <a-select-option v-for="(item, key) in serviceStrategys" :key="key" :value="item.name">
                <a-tag :color="item.color">{{ item.name }}</a-tag>
              </a-select-option>
            </a-select>
          </template>
          <template v-else-if="form.key === 'service_type'">
            <a-select v-model="form.value" placeholder="请选择服务类型">
              <a-select-option :value="1"> 后端 </a-select-option>
              <a-select-option :value="2"> 前端 </a-select-option>
              <a-select-option :value="3"> Apple </a-select-option>
              <a-select-option :value="4"> Android </a-select-option>
            </a-select>
          </template>
          <template v-else-if="['self_deploy', 'auto_deploy'].includes(form.key)">
            <a-switch v-model="form.value" checked-children="开启" un-checked-children="关闭" />
          </template>
          <template v-else-if="form.key === 'special_tests'">
            <a-checkbox-group v-model="form.value" :options="Object.values(serviceSpecialTests)" />
          </template>
          <template v-else-if="form.key === 'projects'">
            <a-select v-model="form.value" mode="multiple" :max-tag-count="5" show-search placeholder="请选择关联项目" :filter-option="utils.filterOption">
              <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }} </a-select-option>
            </a-select>
          </template>
          <template v-else-if="form.key === 'language'">
            <a-input v-model="form.value" placeholder="请填写语言" />
          </template>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { projectList } from '@/api/project/project';
import { serviceBatchModify } from '@/api/system/service';
import { serviceSpecialTests } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';
export default {
  components: { UserSelect },
  props: {
    serviceStrategys: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      serviceSpecialTests,
      visible: false,
      loading: false,
      serviceIds: [],
      projects: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      selectedField: null,
      form: {
        key: 'owner',
        value: null,
        method: 'cover'
      },
      fields: [
        { label: '负责人', value: 'owner' },
        { label: '业务域', value: 'domain' },
        { label: '发布策略', value: 'strategy' },
        { label: '服务类型', value: 'service_type' },
        { label: '自动发布', value: 'auto_deploy' },
        { label: '自助发布', value: 'self_deploy' },
        { label: '专项测试', value: 'special_tests' },
        { label: '关联项目', value: 'projects' },
        { label: '语言', value: 'language' }
      ],
      domainList: [
        {
          label: '通用',
          value: 'COMMON'
        },
        {
          label: '库存',
          value: 'STOCK'
        },
        {
          label: '订单',
          value: 'ORDER'
        },
        {
          label: '商品',
          value: 'GOODS'
        },
        {
          label: '营销',
          value: 'PROMOTION'
        },
        {
          label: '账户',
          value: 'ACCOUNT'
        },
        {
          label: 'BFF',
          value: 'BFF'
        },
        {
          label: '权限',
          value: 'AUTHORITY'
        },
        {
          label: 'DSP',
          value: 'DSP'
        },
        {
          label: '权益中心',
          value: 'EQUITY_CENTER'
        },
        {
          label: '用户会员',
          value: 'USER_MEMBER'
        },
        {
          label: '直播',
          value: 'LIVE'
        },
        {
          label: '乐朗',
          value: 'LUNA'
        }
      ],
      rules: {
        key: [{ required: true, message: '变更项不能为空', trigger: 'blur' }],
        value: [{ required: true, message: '变更值不能为空', trigger: 'blur' }]
      }
    };
  },
  methods: {
    onOpen(serviceIds) {
      this.serviceIds = serviceIds;
      this.visible = true;
      this.form = { key: 'owner', value: null, method: 'cover' };
    },

    // 获取项目列表
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
      });
    },

    handleOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          serviceBatchModify({ service_ids: this.serviceIds, ...this.form })
            .then(() => {
              this.loading = false;
              this.visible = false;
              this.$message.success('批量编辑成功');
              this.$emit('ok');
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    handleCancel() {
      this.visible = false;
    },

    onFieldChange() {
      this.form.value = undefined;
      if (this.form.key === 'projects') {
        this.getProjectList();
      }
      if (['strategy', 'projects', 'special_tests'].includes(this.form.key)) {
        this.form.method = 'append';
      }
    }
  }
};
</script>
